// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cursor-pagination__total[data-v-49f8ea43] {\n  font-weight: normal;\n}\n", ""]);
// Exports
module.exports = exports;
